import type { HTMLComponent } from "@commercekit/react";
import { asText } from "@prismicio/helpers";
import { Link } from "@remix-run/react";
import type { LayoutDocumentDataNavLinksItem } from "~/lib/prismic";

const WvHeaderUSPBar: HTMLComponent<{
  headerUspBar: LayoutDocumentDataNavLinksItem[];
}> = ({ headerUspBar }) => {
  const getCurrentLink = (item: LayoutDocumentDataNavLinksItem) => {
    // Type assertion since the data structure shows link as an array
    const links = item.link as unknown as any[];

    if (!links || links.length === 0) return null;

    if (links.length === 1) {
      return links[0];
    }

    const today = new Date().getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

    if (today >= 1 && today <= 5) {
      // Monday to Friday - show first link
      return links[0];
    } else if (today === 6) {
      // Saturday - show second link (or first if only 2 links)
      return links[1] || links[0];
    } else {
      // Sunday - show third link (or fallback to available links)
      return links[2] || links[1] || links[0];
    }
  };

  return (
    <>
      {headerUspBar && headerUspBar.length > 0 ? (
        <div className="py-2 wvheader-usps px-lg-3">
          <div className="container">
            <div className="carousel">
              <div className="py-1 carousel-track">
                {headerUspBar.map((item, index) => {
                  const currentLink = getCurrentLink(item);

                  return (
                    <div
                      key={`uspbarslice_${(currentLink ?? item).text}_${index}`}
                      className="carousel-slide"
                    >
                      <svg
                        width="13"
                        height="12"
                        xmlns="http://www.w3.org/2000/svg"
                        className="mr-1"
                      >
                        <path
                          d="M11.293.33A.923.923 0 0112.72 1.5l-.013.017-7.754 9.23a.923.923 0 01-1.38.04l-.013-.016L.237 7.08a.923.923 0 011.358-1.25l.014.015 2.613 2.903L11.293.33z"
                          fill="currentColor"
                          fillRule="nonzero"
                        ></path>
                      </svg>
                      {!currentLink || currentLink.link_type === "Any" ? (
                        <span>{asText(item.text)}</span>
                      ) : (
                        <Link
                          to={currentLink.url ?? currentLink.slug}
                          target={currentLink.target}
                        >
                          {currentLink.text}
                        </Link>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default WvHeaderUSPBar;
